import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

const Video = ({
  src,
  ...rest,
}) => (
  <div className="video">
    <video
      className="video__elem"
      src={src}
      autoPlay
      muted
      playsInline
      loop
      {...rest}
    />
  </div>
);

Video.propTypes = {
  src: PropTypes.string.isRequired,
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video/index.js